__turbopack_context__.v({
  "jetCatalogCard": "card-module-scss-module__w3BnCq__jetCatalogCard",
  "jetCatalogCardButton": "card-module-scss-module__w3BnCq__jetCatalogCardButton",
  "jetCatalogCardContent": "card-module-scss-module__w3BnCq__jetCatalogCardContent",
  "jetCatalogCardContentBody": "card-module-scss-module__w3BnCq__jetCatalogCardContentBody",
  "jetCatalogCardContentBodyCategory": "card-module-scss-module__w3BnCq__jetCatalogCardContentBodyCategory",
  "jetCatalogCardContentBodyPriceValue": "card-module-scss-module__w3BnCq__jetCatalogCardContentBodyPriceValue",
  "jetCatalogCardContentHeader": "card-module-scss-module__w3BnCq__jetCatalogCardContentHeader",
  "jetCatalogCardContentHeaderPassengers": "card-module-scss-module__w3BnCq__jetCatalogCardContentHeaderPassengers",
  "jetCatalogCardContentHeaderTitle": "card-module-scss-module__w3BnCq__jetCatalogCardContentHeaderTitle",
  "jetCatalogCardImage": "card-module-scss-module__w3BnCq__jetCatalogCardImage",
  "jetCatalogCardTail": "card-module-scss-module__w3BnCq__jetCatalogCardTail",
  "jetCatalogPopular": "card-module-scss-module__w3BnCq__jetCatalogPopular",
});
